import { useMemo } from 'react'
import React, { FC } from 'react'
import CustomButton from '../UI/Buttons/CustomButton'
import Upload from '../UI/Icons/Upload'

import './PostMediaPlaceholder.scss'

export enum MEDIA_TYPE_TO_UPLOAD {
  IMAGE = 'image',
  VIDEO = 'video',
  MULTY_CONTENT = 'multy-content'
}

type PostMediaPlaceholderProps = {
  onClick: () => void
  mediaType: MEDIA_TYPE_TO_UPLOAD
}

const PostMediaPlaceholder: FC<PostMediaPlaceholderProps> = ({ onClick, mediaType }) => {
  const eventHandler = (e: React.FormEvent<HTMLButtonElement>) => {
    e.currentTarget.blur()
    onClick()
  }

  const placeholderData = useMemo(() => {
    let text = '', buttonText = ''

    switch (mediaType) {
      case MEDIA_TYPE_TO_UPLOAD.IMAGE:
        text = 'Drag images here'
        buttonText = 'Choose images'
        break;
      case MEDIA_TYPE_TO_UPLOAD.VIDEO:
        text = 'Drag videos here'
        buttonText = 'Choose videos'
        break;
      case MEDIA_TYPE_TO_UPLOAD.MULTY_CONTENT:
        text = 'Drag media files here'
        buttonText = 'Choose media files'
        break;
    }
    return {
      text,
      buttonText
    }
  }, [mediaType])

  return (
    <div className='media-placeholder'>
      <Upload />
      <div className='media-placeholder__name'>
        {placeholderData.text}
      </div>
      <div className='media-placeholder__choice'>or</div>
      <CustomButton onClick={eventHandler} button='primary' type='button'>
        {placeholderData.buttonText}
      </CustomButton>
    </div>
  )
}

export default PostMediaPlaceholder
